<div class="layout-conatiner text" [ngStyle]="style" *ngIf="alarm">
    <div class="detail-container">
        <div>
            <div class="detail-title">
                <div>{{ "alarm.table.header.alarm" | translate }}</div>
            </div>
            <div class="detail-content">
                <div>{{ alarm.name | uppercase }}</div>
            </div>
        </div>
        <div>
            <div class="detail-title">
                <div>{{ "alarm.table.header.channelNumber" | translate }}</div>
            </div>
            <div class="detail-content">
                <div>{{ alarm.channel }}</div>
            </div>
        </div>
        <div>
            <div class="detail-title">
                <div>{{ "alarm.table.header.status" | translate }}</div>
            </div>
            <div class="detail-content">
                <div class="status">
                    <app-alarm-status-icon [statusText]="alarm.level">
                    </app-alarm-status-icon>
                    <div>{{ alarm.status | uppercase }}</div>
                </div>
            </div>
        </div>
        <div>
            <div class="detail-title">
                <div>{{ "alarm.table.header.value" | translate }}</div>
            </div>
            <div class="detail-content">
                <div>{{ alarm.value | uppercase }}</div>
            </div>
        </div>

        <div>
            <div class="detail-title">
                <div>{{ "alarm.table.header.category" | translate }}</div>
            </div>
            <div class="detail-content">
                <div>{{ alarm.category }}</div>
            </div>
        </div>
        <div>
            <div class="detail-title">
                <div>{{ "alarm.table.header.occurence" | translate }}</div>
            </div>
            <div class="detail-content">
                <div>
                    {{ alarm.occurredAt | date: "yyyy/MM/dd" : "UTC" }}
                    {{ alarm.occurredAt | date: "HH:mm" : "UTC" }}
                </div>
            </div>
        </div>
        <div>
            <div class="detail-title">
                <div>{{ "alarm.table.header.update" | translate }}</div>
            </div>
            <div class="detail-content">
                <div>
                    {{ alarm.updatedAt | date: "yyyy/MM/dd" : "UTC" }}
                    {{ alarm.updatedAt | date: "HH:mm" : "UTC" }}
                </div>
            </div>
        </div>
        <div>
            <button (click)="setVisible(false)">
                {{ "alarm.button.close" | translate }}
            </button>
        </div>
    </div>
</div>
